<div [class]="classType">
  <p [ngClass]="{'common__col-text': !inheritedClass,
    'common__inherited-text-tooltip': inheritedClass,
    'common__col-text--cursor': cursor}">
      <span-tooltip
        [text]="text"
        [isDeleted]="isDeleted"></span-tooltip>
  </p>
</div>
